import { ImmHelper } from "@base/util/Immutable";
import { mapRecord } from "@base/util/TypeUtil";
import { ProductData3d } from "@biz/definitions/IVariantData3d";
import { IPowderCoatingProduct, PowderCoating, VERSION_POWDER_COATING } from "@biz/definitions/PowderCoatingDefinitions";
import { FeatureLevel, MeasureVisibility } from "@biz/definitions/ProductDefinitions";
import { IShoppingListItem } from "@biz/models/ShoppingListDefinitions";
import { getProductReducers } from "@biz/reducers/CommonReducers";
import { getNotesAndFilesReducer } from "@biz/reducers/NotesAndFilesReducer";

export function getProduct3dReducers<T extends ProductData3d>() {
  return {
    ...getNotesAndFilesReducer<T>(),
    ...getProductReducers<T>(),
    enablePowderCoating(old: T, flag: boolean): T {
      return updatePowderCoating(old, (pc) => ImmHelper.setProperty(pc, "flag", flag))
    },
    setPowderCoatingColor(old: T, color: string | undefined, index: number): T {
      return updatePowderCoating(old, (pc) => ImmHelper.setArrayItem(pc, "colors", index, color))
    },
    addPowderCoatingColor(old: T): T {
      return updatePowderCoating(old, (pc) => ImmHelper.pushArrayItem(pc, "colors", PowderCoating.DEFAULT_COLOR))
    },
    removePowderCoatingColor(old: T, index: number): T {
      old = {
        ...old,
        shoppingList: {
          ...old.shoppingList,
          items: mapRecord(old.shoppingList.items, (item) => {
            // totest
            return removePowderCoatingIndex(item, index);
          })
        }
      }
      old = updatePowderCoating(old, (pc) => {
        return ImmHelper.removeArrayItem(pc, "colors", index)
      })
      return old;
    },
    setMeasureVisibility(old: T, measureName: MeasureVisibility, flag: boolean): T {
      return {
        ...old,
        measures: {
          ...old.measures,
          [measureName]: flag
        }
      }
    },
    setFeatureLevel(old: T, featureLevel: FeatureLevel): T {
      return ImmHelper.setProperty(old, "featureLevel", featureLevel)
    }
  }
}

function updatePowderCoating<T extends ProductData3d>(old: T, fn: (powderCoating: IPowderCoatingProduct) => IPowderCoatingProduct | undefined): T {
  const powderCoating: IPowderCoatingProduct = (old?.powderCoating?.version || 0) >= VERSION_POWDER_COATING ? old.powderCoating! : { version: VERSION_POWDER_COATING, flag: false, colors: [PowderCoating.DEFAULT_COLOR] }
  return {
    ...old,
    powderCoating: fn(powderCoating)
  }
}

function removePowderCoatingIndex(item: IShoppingListItem, index: number): IShoppingListItem {
  if (item.powderCoatingIndex === undefined)
    return item;
  if (item.powderCoatingIndex > index)
    return { ...item, powderCoatingIndex: item.powderCoatingIndex - 1 }
  if (item.powderCoatingIndex === index)
    return { ...item, powderCoatingIndex: undefined }
  return item;
}